import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { Daycare } from '@/types/Daycare'
import ExportDialog from '../exportDialog.tsx'
import { ExportDataType } from '@/types/Export.ts'

interface ExportOccasionalSlotsProps {
    daycares: Daycare[]
    isRpeOrLaep: boolean
    minDate: string
}

const ExportOccasionalSlots: FunctionComponent<ExportOccasionalSlotsProps> = ({
    daycares,
    isRpeOrLaep,
    minDate
}: ExportOccasionalSlotsProps) => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{isRpeOrLaep ? t('animationSlots') : t('occasionalSlots')}</p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ExportDialog
                    type={ExportDataType.OccasionalSlots}
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={daycares}
                    minDate={minDate}
                    isRpeOrLaep={isRpeOrLaep}
                />
            )}
        </>
    )
}

export default ExportOccasionalSlots
